import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { connect } from 'react-redux';
import { asyncUpdateProvider } from 'src/store/actions/provider-actions';
import { toast } from 'react-toastify';
import { IProvider } from 'src/types/provider';
import { ISeance } from 'src/types/seance';
import user from 'src/services/user-auth';
import { DropdownList } from 'react-widgets';
import { getValFromEnum } from '../../../../../../../components/redux-form/utils/dropdown-values';
import UserRole from '../../../../../../../enumerables/user-role';
import { Button, Modal } from 'react-bootstrap';
import { Paginated } from 'src/services/api-handlers/pagination';
import { getSeances, getSeancesEmpty } from '../../../../../../../store/actions/seance-actions';
import { StoreState } from '../../../../../../../store/reducers';
import Loader from '../../../../../../../components/Loader';

export interface StateProps {
    seances: Paginated<ISeance>;
    inProgress: boolean;
}

export interface DispatchProps {}

export interface OwnProps {
    data: IProvider;
}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const StatusProviderAction: React.FunctionComponent<Props> = ({
    data: { id, status, fullName },
    seances,
    inProgress,
}: Props) => {
    const dispatch = useDispatch();
    const [opened, setOpened] = useState<number | boolean>(false);
    const handleClose = () => {
        setOpened(false);

        dispatch(
            getSeancesEmpty({
                list: [],
                page: 1,
                meta: {
                    updatedAt: null,
                },
                inProgress: false,
            }),
        );
    };

    React.useEffect(() => {
        if (opened === id && !seances.list.length && seances.pageSize) {
            asyncUpdateProvider(
                { userId: id, status: 2 },
                dispatch,
                () => false,
                (errorMessage: string) => toast.error(errorMessage),
            );
            handleClose();
        }
        // eslint-disable-next-line
    }, [opened, inProgress]);
    const onChangeDrop = (st: number) => {
        if (st === 2) {
            dispatch(
                getSeances({
                    page: 1,
                    filters: {
                        'provider.id': id,
                        status: [1, 3, 4, 8],
                    },
                }),
            );
            setOpened(+id);
        } else {
            asyncUpdateProvider(
                { userId: id, status: st },
                dispatch,
                () => false,
                (errorMessage: string) => toast.error(errorMessage),
            );
        }
    };
    let arrStatValue: any = {};
    let canChoose = false;
    const avaibleStatuses: any = user.getUserAvailableStatus();
    Object.keys(avaibleStatuses).forEach((it: any) => {
        if (status === +avaibleStatuses[it]) {
            arrStatValue = { label: it, value: +avaibleStatuses[it] };
            canChoose = true;
        }
    });

    let labelStatus = '';
    if (!canChoose) {
        const allStatuss: any = user.getAllStatuses();
        Object.keys(allStatuss).forEach((it: any) => {
            if (status === +allStatuss[it]) {
                labelStatus = it;
            }
        });
    }

    const selectValuesStatus: SelectObject[] = getValFromEnum(avaibleStatuses);
    return (
        <>
            <div style={{ minWidth: 100, position: 'relative' }}>
                {inProgress && +opened === id ? <Loader noFull={true} /> : null}
                {canChoose ? (
                    <DropdownList
                        data={selectValuesStatus}
                        disabled={!user.getRoles().includes(UserRole.ROLE_ADMIN)}
                        containerClassName={'w-100'}
                        textField="label"
                        valueField="value"
                        onChange={(item: SelectObject) => {
                            onChangeDrop(item.value);
                        }}
                        value={arrStatValue}
                    />
                ) : (
                    labelStatus
                )}
            </div>
            <Modal show={+opened === id && seances.list.length} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {' '}
                    Provider {`${fullName}`} has sessions. Are you sure you want to inactivate this provider?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button
                        variant="danger"
                        onClick={() => {
                            asyncUpdateProvider(
                                { userId: id, status: 2 },
                                dispatch,
                                () => toast.success('Status changed successfully'),
                                (errorMessage: string) => toast.error(errorMessage),
                            );
                            handleClose();
                        }}
                    >
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default connect<StateProps, DispatchProps, OwnProps, StoreState>(
    (state) => ({
        seances: state.seances.data,
        inProgress: state.seances.inProgress,
    }),
    {},
)(StatusProviderAction);
